import * as React from 'react';
import { Paper, Typography } from "@mui/material";
import Zoom from '@mui/material/Zoom';
import styles from "../css/gis.module.css"


export const PopupViewStop = ({ item }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)

    // 오버플로우 상태를 추적할 ref와 state
    const nmRef = React.useRef(null);
    const idRef = React.useRef(null);
    const [nmOverflow, setNmOverflow] = React.useState(false);
    const [idOverflow, setIdOverflow] = React.useState(false);

    React.useEffect(() => {
        setTransitionIn(false);
        const key = setTimeout(() => {
          setTransitionIn(true);

    // DOM이 확실히 렌더링된 후 측정
    if (nmRef.current) {
        const nmEl = nmRef.current;
        const overflow = nmEl.scrollWidth > nmEl.clientWidth;
        console.log("nmRef", { scrollWidth: nmEl.scrollWidth, clientWidth: nmEl.clientWidth, overflow });
        setNmOverflow(overflow);
      }
      if (idRef.current) {
        const idEl = idRef.current;
        const overflow = idEl.scrollWidth > idEl.clientWidth;
        console.log("idRef", { scrollWidth: idEl.scrollWidth, clientWidth: idEl.clientWidth, overflow });
        setIdOverflow(overflow);
      }
    }, 400); // Zoom in 이후에 측정되도록 타이밍 확보
  
    return () => clearTimeout(key);
  }, [item.id, item.nm]);

    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className={`${styles.gisPopup_stop} gisPopup flx flx_col gap6`}>
                {/* <div className='popTit'>정류장 <span className='id'>{item.nm}</span></div> */}
                <div className='flx a_center'>
                    <div className='popTit'>정류장</div>
                    <div className={`${styles.flow_wrap_stop} flow_wrap`} ref={nmRef}>
                        <span className={`flow_txt ${nmOverflow ? "animate-delay" : ""}`}>{item.nm}</span>
                    </div>
                </div>
                <div className='flx a_center w_100'>
                    <div className='popTit'>ID</div>
                    <div className='popTxt'>{item.id}</div>
                </div>
                <div class="flx a_center gap20">
                    <div className='flx a_center' style={{width:'50%'}}>
                        <div className='popTit'>승차</div>
                        {
                            item.inCnt ?
                            <div className='gr'>{item.inCnt}</div>:<div className='popTxt'>-</div>
                        }                    
                    </div>
                    <div className='flx a_center' style={{width:'50%'}}>
                        <div className='popTit'>하차</div>
                        <div className='popTxt'>{item.outCnt ? item.outCnt : '-'}</div>
                    </div>
                </div>
            </div>
        </Zoom>
    )
}